import OrderManagementModule from "@/modules/OrderManagement";

function OrderManagementPage() {
  return <OrderManagementModule />;
}

export default OrderManagementPage;
